// @ts-nocheck





import {
  fetchRequest,
  initialFetchListParams,
  downloadRequestWithToken } from
'./index';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

export const convertDataFromServer = (stockPart) => ({
  ...stockPart,
  cost: convertFromKopToRub(stockPart.cost),
  sparePart: stockPart.sparePart ?
  {
    ...stockPart.sparePart,
    price: convertFromKopToRub(stockPart.sparePart.price)
  } :
  undefined
});

export const convertDataToServer = (stockPart) => ({
  ...stockPart,
  cost: convertFromRubToKop(stockPart.cost),
  sparePart: stockPart.sparePart ?
  {
    ...stockPart.sparePart,
    price: convertFromRubToKop(stockPart.sparePart.price)
  } :
  undefined
});

export const fetchStockPart = async (
params = initialFetchListParams) =>
{
  const stockPart = await fetchRequest.get('/stockPart', {
    ...initialFetchListParams,
    ...params
  });
  if (stockPart)
  return {
    ...stockPart,
    data: stockPart.data.map(convertDataFromServer)
  };
  throw new Error('Не удалось получить список запчастей со склада');
};

export const getStockPart = async (id) => {
  const stockPart = await fetchRequest.get(`/stockPart/${id}`);
  if (stockPart) return convertDataFromServer(stockPart);
  throw new Error('Не удалось получить информацию по детали');
};

export const addStockPart = async (
stockPart) =>
{
  const added = await fetchRequest.post(
    `/stockPart`,
    convertDataToServer(stockPart)
  );
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось добавить запчасть на склад');
};

export const updateStockPart = async (
stockPart) =>
{
  const updeted = await fetchRequest.put(
    `/stockPart`,
    convertDataToServer(stockPart)
  );
  if (updeted) return convertDataFromServer(updeted);
  throw new Error('Не удалось отредактировать информацию о запчасти');
};

export const deleteStockPart = async (id) => {
  const deleted = await fetchRequest.delete(`/stockPart/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалось запчасть');
};

export const subscribeParusStockParts = async () => {
  const accounts = await fetchRequest.get(
    `/stockPart/parus/subscribe/stockParts`,
    {}
  );
  if (accounts) return accounts;
  throw new Error('Не удалось подписаться на обновления по складам!');
};

export const updateParusStockParts = async (params) => {
  const accounts = await fetchRequest.get(
    `/stockPart/parus/updateStockParts`,
    params
  );
  if (accounts) return accounts;
  throw new Error('Не удалось подписаться на обновления по складам!');
};

const print = async (filter) => {
  const print = await downloadRequestWithToken(`/stockPart/print`, filter);
  if (print) return print;
  throw new Error('Не удалось распечатать перечень материалов');
};

export default {
  print,
  fetchStockPart,
  getStockPart,
  addStockPart,
  updateStockPart,
  deleteStockPart,
  subscribeParusStockParts,
  updateParusStockParts
};
